module.exports = __webpack_public_path__ + "img/yyzc.ae3ef4bd.png";